<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 16px;">

  <!-- Amount header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0; text-align: center;">
    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
      <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #1C593D;">account_balance_wallet</mat-icon>
      <span style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f;">
        {{ montoRetiro | number:'1.2-2' }} VES
      </span>
    </div>
  </div>

  <!-- Account details -->
  <div style="padding: 20px;">
    <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Datos del beneficiario</h3>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">person</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Beneficiario</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ account?.nombre }} {{ account?.apellidos }}</span>
    </div>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">account_balance</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Banco</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ account?.banco?.nombre | titlecase }}</span>
    </div>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">credit_card</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Tipo de cuenta</span>
      <span *ngIf="account?.movilPay !== 1" style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ account?.tipoCuenta?.nombre }}</span>
      <span *ngIf="account?.movilPay === 1" style="font-size: 0.78rem; font-weight: 700; color: #92400e; background: #fef3c7; padding: 2px 8px; border-radius: 4px;">Pago M&oacute;vil</span>
    </div>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">pin</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">{{ account?.movilPay === 1 ? 'Tel&eacute;fono' : 'N&ordm; de cuenta' }}</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f; font-family: monospace;">{{ account?.movilPay === 1 ? '(+58) ' + account?.numeroCuenta : account?.numeroCuenta }}</span>
    </div>
  </div>
</div>

<!-- Desglose comisi&oacute;n -->
<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 16px 20px; margin-bottom: 16px;">
  <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 12px;">Detalle del retiro</h3>
  <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0;">
    <span style="font-size: 0.78rem; color: #6b7280; font-weight: 500;">Monto a retirar</span>
    <span style="font-size: 0.82rem; font-weight: 700; color: #1f2937;">{{ montoRetiro | number:'1.2-2' }} VES</span>
  </div>
  <div style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0; border-top: 1px solid #e5e7eb;">
    <span style="font-size: 0.78rem; color: #6b7280; font-weight: 500;">Comisi&oacute;n interbancaria</span>
    <span style="font-size: 0.82rem; font-weight: 700; color: #dc2626;">- {{ comisionVes | number:'1.2-2' }} VES</span>
  </div>
  <div style="display: flex; align-items: center; justify-content: space-between; padding: 8px 0 2px; border-top: 2px solid #bbf7d0;">
    <span style="font-size: 0.8rem; color: #1e5a3f; font-weight: 700;">Recibe el beneficiario</span>
    <span style="font-size: 0.95rem; font-weight: 800; color: #1e5a3f;">{{ montoRecibido | number:'1.2-2' }} VES</span>
  </div>
</div>

<!-- Confirm button -->
<button type="button" (click)="confirmarEnvio()" [disabled]="isSubmitting"
  [style.opacity]="isSubmitting ? '0.5' : '1'"
  [style.cursor]="isSubmitting ? 'not-allowed' : 'pointer'"
  style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
  onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isSubmitting ? 'hourglass_top' : 'check_circle' }}</mat-icon>
  {{ isSubmitting ? 'Procesando...' : 'Confirmar retiro' }}
</button>
